<template>
    <mdc-dialog v-model="isOpen"
                :title="'protocol.confirm_change' | trans"
                :accept="'user.save' | trans"
                :cancel="'user.cancel' | trans"
                @accept="accept"
                @cancel="close"/>
</template>

<script>
  export default {
    name: 'DeleteTherapistModal',
    props: {
      'visible': {
        type: Boolean,
        default() {
          return false;
        },
      },
    },
    computed: {
      isOpen: {
        get() {
          return this.visible;
        },
        set() {},
      },
    },
    methods: {
      accept() {
        this.$emit('accept');
      },
      close() {
        this.$emit('close');
      },
    },
  };
</script>


// WEBPACK FOOTER //
// src/modules/protocols/components/ConfirmChangeModal.vue